import type { Account } from './account';
import type { ConstValues } from './helpers';
import type { HierarchyItem } from './hierarchyItem';
import type { StateUtil } from './stateUtil';

export const OptionsType = {
  USER_ROLES: 'userRoles',
  LOCALES: 'locales',
  STATUSES: 'statuses',
  REPORT_RANGES: 'reportRanges',
  EXPERIENCES: 'experiences',
  AD_CATEGORIES: 'adCategories',
  TARGETABLE_DEMAND_CRITERIA: 'targetableDemandCriteria',
  BUYERS: 'buyers',
  AGENCIES: 'agencies',
  BRANDS: 'brands',
  ACCOUNT_PARTNERS: 'accountPartners',
  PARTNER_REGIONS: 'partnerRegions',
  COUNTRIES: 'countries',
  CONTEXTUAL_PROVIDERS: 'contextualProviders',
  MARKET_BRAND_GROUPS: 'marketBrandGroups',
  MARKET_BRANDS: 'marketBrands',
  DOMAIN_CATEGORIES: 'domainCategories',
  DOMAIN_AUDIENCE_TYPES: 'domainAudienceTypes',
  DOMAIN_BAN_REASONS: 'domainBanReasons',
  CURRENCIES: 'currencies',
  ACCOUNTS: 'accounts',
  GENRE: 'genre',
  NETWORK_ACCOUNTS: 'networkAccounts',
  ALL_DEMAND_PARTNERS: 'allDemandPartners',
  PMP_DEAL_TYPE: 'pmpDealType',
  DEAL_SOURCE: 'dealSource',
  TARGETABLE_DEMAND_PARTNER: 'targetableDemandPartner',
  NETWORK_N_PUBLISHERS_ACCOUNTS: 'networkAndPublisherAccounts',
  PUBLISHERS_ACCOUNTS: 'publisherAccounts',
  ACTIVE_PUBLISHERS_ACCOUNTS: 'activePublisherAccounts',
  OPEN_AUCTION_ACCESS: 'openAuctionAccess',
  CONTENT_ATTRIBUTE: 'contentAttributes',
  CREATIVE_TYPES: 'creativeTypes',
  LANGUAGE: 'language',
  MOBILE_DEVICES: 'mobile_devices',
  DESKTOP_DEVICES: 'desktop_devices',
  TV_DEVICES: 'tv_devices',
  OLD_DEVICE_TYPE: 'old_device_type',
  OS: 'os',
  PMP_SIZE: 'pmpSize',
  APP_CATEGORIES_BAN_REASONS: 'appCategoriesBanReasons',
  APP_APPINFO_ORIGINS: 'appAppInfoOrigins',
  APP_CATEGORIES_PLATFORMS: 'appCategoriesPlatforms',
  LINEARVIDEO_LOCATION: 'linearvideoLocation',
  LINEARVIDEO_PRESENTATION_FORMAT: 'linearvideoPresentationFormat',
  LINEARVIDEO_SIZE: 'linearvideoSize',
  VIDEO_API_FRAMEWORK: 'videoApiFramework',
  VIDEO_FORMAT: 'videoFormat',
  VIDEO_PLACEMENT: 'videoPlacement',
  VIDEO_PROTOCOL: 'videoProtocol',
  VIEWABILITY: 'viewability',
  AUDIENCE_ACCOUNTS: 'audienceAccounts',
  BROWSER: 'browsers',
  TARGETING_LANGUAGE: 'targetingLanguages',
  SIZES: 'sizes',
  MOBILE_PRESENTATION_FORMAT: 'mobilePresentationFormat',
  MOBILE_API_FRAMEWORK: 'mobileApiFramework',
  ADUNIT_VIDEO_MIME_TYPE: 'adunitVideoMimeType',
  LINEARITY: 'linearity',
  NONLINEARCTV_API_FRAMEWORK: 'nonlinearctvApiFramework',
  NONLINEARCTV_MIME_TYPE: 'nonlinearctvMimeType',
  NONLINEARCTV_PLAYBACKMETHOD: 'nonlinearctvPlaybackmethod',
  NONLINEARCTV_POSITION: 'nonlinearctvPosition',
  NONLINEARCTV_PRESENTATION_FORMAT: 'nonlinearctvPresentationFormat',
  PLAYBACKMETHOD: 'playbackmethod',
  VIEW_THROUGH_RATE: 'vtr_score_options',
  MOBILE_LOCATION: 'mobileLocation',
  WEB_LOCATION: 'webLocation',
  CONTENT_TYPE: 'contentType',
  CONTENT_TOPIC: 'contentTopic',
  DEAL_STATUS: 'dealStatus',
  DEAL_TYPE: 'dealType',
  EMAIL_LOCATION: 'emailLocation',
  VIDEO_COMPANION_LOCATION: 'videoCompanionLocation',
  NON_LINEARVIDEO_LOCATION: 'nonLinearvideoLocation',
  EXT_SUPPLY_PARTNER: 'extSupplyPartner',
  PARTNER_TYPE: 'partnerType',
  DISTRIBUTION_CHANNEL: 'distributionChannel',
  OLD_DISTRIBUTION_CHANNEL: 'oldDistributionChannel',
  AD_PLACEMENT: 'adPlacement',
  OLD_AD_PLACEMENT: 'oldAdPlacement',
  OPTIMIZATION_ACCOUNTS: 'optimizationAccounts',
  MARKET_DELIVERY_MEDIUM: 'marketDeliveryMedium',
  FEE_REASON_OPTIONS: 'feeReasonOptions',
  MARKET_OPERATORS: 'marketOperators',
  MARKET_ADVERTISERS: 'markerAdvertisers',
  SSRTB_METRICS: 'ssrtbMetrics',
  SSRTB_ENRICHMENT_FEATURES: 'ssrtbEnrichmentFeatures',
  SSRTB_PREFERRED_TAXONOMY: 'ssrtbPreferredTaxonomy',
  TIMEZONE: 'timezoneOptions',
  TRAFFIC_FILTER_EIDS: 'trafficFilterEids',
  COMPRESSION: 'compression',
  DATA_CENTER: 'dataCenter',
  SEAT: 'seat',
  SEAT_REGIONS: 'seatRegions',
  DEAL: 'deal',
  METACATEGORIES: 'metacategories',
  A_DOMAINS: 'adomains',
  EXCHANGE_SIZE_OPTIONS: 'exchangeSizeOptions',
  CONTENT_RATING: 'contentrating',
  RTB_CONTENT_FORWARDING_DSP: 'rtb_content_forwarding_dsp',
  RTB_CONTENT_FORWARDING_OTHER_DSPS: 'rtb_content_forwarding_other_dsps',
  RTB_FORWARDING_POLICY_ALLOWED_SIGNALS: 'rtb_forwarding_policy_allowed_signals',
  SITES_WITH_ACCOUNT_INFO: 'sitesWithAccountInfo',
  LOCATION_SOURCE_OPTIONS: 'locationSourceOptions',
  CONNECTION_SPEED: 'connectionSpeed',
  CONNECTION_TYPE: 'connectionType',
  DEVICE: 'device',
  SCREEN_RESOLUTION: 'screenResolution',
  MOBILE_CARRIER: 'mobileCarrier',
  DEAL_AD_CATEGORY: 'dealAdCategory',
  CRT_SENSITIVE_CATEGORY_TO_INDUSTRY_MAPPING: 'CrtSensitiveCategoryToIndustryMapping',
  RECONCILIATION_PARTNER: 'reconciliationPartner',
  PUBLISHER: 'publisher',
  PDP_SYNC_DEAL_STATUS_OPTIONS: 'pdpSyncDealStatusOptions',
  PDP_SYNC_NEGOTIATION_STATUS_OPTIONS: 'pdpSyncNegotiationStatusOptions',
  PDP_SYNC_STATUS_OPTIONS: 'pdpSyncStatusOptions',
  AMAZON_SYNC_STATUS_OPTIONS: 'amazonSyncStatusOptions',
  THIRD_PARTY_PARTNERS: 'thirdPartyPartners',
  BLOCK_IRRELEVANT_TARGETING_SCHEMA: 'blockIrrelevantTargetingParamsSchema',
  BUYER_ORGANIZATIONS_OPTIONS: 'buyer_organizations_options',
  OXS_ACCOUNT: 'oxsAccount',
} as const;
export type OptionsType = ConstValues<typeof OptionsType>;

export const ParameterizedOptionsType = {
  DEMAND_PARTNER_BUYER_SEATS: 'demandPartnerBuyerSeats',
  DEMAND_PARTNER_BUYER: 'demandPartnerBuyer',
  TARGETABLE_PACKAGE: 'targetablePackage',
  THIRD_PARTY_PARTNERS: 'thirdPartyPartners',
  PUBLISHERS: 'publishers',
  DMP_SEGMENTS: 'dmp_segments',
  OPEN_AUDIENCES: 'openaudience_custom',
  ACCOUNT_EXECUTIVE: 'accountExecutive',
  ACCOUNT_MANAGER: 'accountManager',
  ORDER: 'order',
} as const;
export type ParameterizedOptionsType = ConstValues<typeof ParameterizedOptionsType>;

export type BaseOption = {
  id: string;
  name: string;
};

export interface ThirdPartySeat {
  demand_partner_id: string;
  seat_id: string;
  platform_seat_name: string | null;
}

export type OptionApi<Tid extends string | number = string, TName extends string | null = string> = {
  id: Tid;
  name: TName;
};

export interface Option extends BaseOption {
  status?: string;
  parent?: string;
  children?: HierarchyItem[];
  parent_name?: string;
  sort_id?: number;
  parent_id?: string | null;
  acl?: string;
  third_party_buyer_id?: string[];
  third_party_seat?: ThirdPartySeat[];
  default_share?: string | null;
  cat_level?: number | string;
  level?: number;
  standard?: string;
  ancestors_names?: string[];
  instance_name?: string;
  adomain?: string;
  accounts?: {
    id: string;
    name: string;
    timestamp: string;
  }[];
  legacy_id?: string | number;
  object?: string;
  hierarchy_path?: string[];
  tooltip?: string;
  description?: string | null;
  disabled?: boolean;
  show_on_top?: number;
  enrichment_features?: {
    retargeting?: boolean;
    tracking_frames?: boolean;
  };
}

export interface BuyerOption {
  id: string;
  name: string;
  buyer_id: string;
  seat_id?: string;
  platform_seat_name?: string;
}

export interface AccountOption extends BaseOption {
  object: string;
}

export interface UserRoleOption extends BaseOption {
  description?: string;
  acl?: string;
}

export type OptionsMap = Record<string, Option>;

export type WithChildren<T> = T & { children: HierarchyItem[] };

export type OptionsList = Option[];

export type OptionsFetchQueryResult = {
  list: OptionsList;
  data: OptionsMap;
};

export type Standard = 'allowed' | 'blocked';

export type CreativeTypeOptionsApi = {
  standard: Standard;
} & BaseOption;

export type ContentAttributeOptionsApi = {
  standard: Standard;
} & BaseOption;

export type BrandGroupOptionsApi = {
  standard: Standard;
  parent_group_name: string;
} & BaseOption;

export type MarketAdvertiserOptionsApi = {
  systemregion_id: string;
  account_id: string;
  uid: string;
} & BaseOption;

export type ThirdPartyPartnerOptionApi = BaseOption &
  // TODO UIG-706: remove the `Required` type helper
  Required<
    Pick<
      Account,
      | 'default_cpm_cap'
      | 'default_fees_description'
      | 'default_platform_share_ox_sourced'
      | 'default_platform_share_partner_sourced'
      | 'default_share'
      | 'max_cpm_cap'
      | 'max_share'
    >
  >;

export type OptionStateMap<o extends BaseOption = Option> = Omit<StateUtil<o>, 'list'>;
export type OptionStateList<o extends BaseOption = Option> = Omit<StateUtil<o>, 'mapById'>;

export type OptionState<o extends BaseOption = Option> = StateUtil<o>;

export type OptionsState = Record<OptionsType, OptionState>;

export const mapJsonToOptions = (jsonArray: { id: NonNullable<unknown> }[]) =>
  jsonArray.map(
    option =>
      ({
        ...option,
        id: option.id.toString(),
      }) as Option
  );
